import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetCascadeLogRequest = App.Http.Requests.Cascade.GetCascadeLogRequest;
import GetCascadeLogResponse = App.Http.Responses.Cascade.GetCascadeLogResponse;
import GetCascadeLogsRequest = App.Http.Requests.Cascade.GetCascadeLogsRequest;
import GetCascadeLogsResponse = App.Http.Responses.Cascade.GetCascadeLogsResponse;

class ProcessesApi extends TenantBaseApi {
    async getLogs(request: GetCascadeLogsRequest): Promise<GetCascadeLogsResponse> {
        return await this.get<GetCascadeLogsResponse, GetCascadeLogsRequest>("/processes/log", {
            params: request,
        });
    }

    async getLog(logId: string, request?: GetCascadeLogRequest): Promise<GetCascadeLogResponse> {
        return await this.get<GetCascadeLogResponse, GetCascadeLogRequest>(`/processes/log/${logId}`, {
            params: request,
        });
    }

    async exportLogs(request?: App.Http.Requests.BaseExportRequest): Promise<App.Http.Responses.ExportResponse> {
        return await this.post<App.Http.Responses.ExportResponse, App.Http.Requests.BaseExportRequest>(
            `/processes/log/export`,
            request
        );
    }
}

export const processesApi = new ProcessesApi();
